import { forwardRef } from "react";
import { regex, useInput } from "react-admin";

import { TagsField } from "./TagsField";

interface Props {
  source: string;
  label?: string;
  placeholder?: string;
}

export const TagsFieldWrapper = forwardRef(({ source, ...props }: Props, ref) => {
  const { field } = useInput({
    source,
    defaultValue: [],
    validate: [regex(/^[a-zA-Z0-9.]*$/, "Labels can only contain letters, numbers, and periods")]
  });

  return <TagsField {...props} {...field} ref={ref} helperText="Separate labels with ENTER" />;
});
